import React, { useState, useCallback } from "react";
import { BellIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../contexts/AuthContext";
import { ensurePushSubscription, isPushSupported, getPermissionStatus } from "../utils/push";
import { toastError, toastSuccess } from "../utils/toast";

const NotificationsButton = () => {
  const { activeCongregazione, pushStatus, refreshPushStatus } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (!isPushSupported()) {
      toastError("Notifiche push non supportate su questo dispositivo/browser");
      return;
    }
    const perm = getPermissionStatus();
    if (perm === "denied") {
      toastError("Permesso notifiche negato. Abilitalo dalle impostazioni del browser.");
      return;
    }
    setLoading(true);
    try {
      const status = await refreshPushStatus();
      const subscriptionsCount =
        status?.subscriptions ?? pushStatus?.subscriptions ?? 0;
      if (subscriptionsCount > 0) {
        toastSuccess("Le notifiche push sono già attive su questo dispositivo");
        return;
      }
      await ensurePushSubscription({
        congregazioneId: activeCongregazione?.id,
      });
      await refreshPushStatus();
      toastSuccess("Notifiche attivate su questo dispositivo");
    } catch (err) {
      console.error("Errore attivazione push:", err);
      toastError(err.message || "Impossibile attivare le notifiche");
    } finally {
      setLoading(false);
    }
  }, [activeCongregazione?.id, pushStatus?.subscriptions, refreshPushStatus]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className="relative inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 transition focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-50"
      title={
        loading
          ? "Attivazione in corso..."
          : "Attiva le notifiche push su questo dispositivo"
      }
      disabled={loading}
    >
      <BellIcon className="h-5 w-5" />
      <span className="sr-only">Notifiche</span>
      {loading && (
        <span className="absolute -top-1 -right-1 bg-primary-500 text-white text-[10px] px-1.5 py-0.5 rounded-full">
          …
        </span>
      )}
    </button>
  );
};

export default NotificationsButton;
